module.exports = __webpack_public_path__ + "static/media/TripAdvisor.405665ae.png";